function getSelectedFilters(items = []) {
  return Object.keys(items).reduce((acc, filter) => {
    if (items[filter] === '1') {
      return [...acc, filter]
    }

    return acc
  }, [])
}

export default getSelectedFilters
